import { Injectable } from '@angular/core';

import { AppServiceCommand } from '../models/app-service-command.model';
import { AppServiceResponse } from '../models/app-service-response.model';

/**
 * App Service Connection interface.
 */
@Injectable()
export abstract class AppServiceConnection {

    /**
     * Sends commands to the app service
     *
     * @param commands Commands to be sent to the app service
     * @returns Response from app service
     */
    public abstract sendCommands(commands: Array<AppServiceCommand>): Promise<AppServiceResponse>;
}
